<template>
  <svg
      :class="svgClass"
      :style="{ width: size, height: size, color: color }"
      v-on="$attrs"
  >
    <use :xlink:href="iconName" />
  </svg>
</template>
<script>

import {reactive, toRefs} from 'vue'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'SvgIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: '24px'
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.name}`
    },
    svgClass() {
      return this.className ? 'svg-icon ' + this.className : 'svg-icon'
    }
  },
  setup() {
    const data = reactive({
    })// 数据
    const methods = {} // 事件

    return {
      ...toRefs(data),
      ...methods
    }
  }
}
</script>
<style scoped lang="scss">
.svg-icon {
  display: inline-block; /* 确保正确的显示 */
  width: 1em; /* 使用相对单位，如em，便于控制大小 */
  height: 1em;
  overflow: hidden;
  vertical-align: -0.15em; /* 可选的垂直对齐调整 */
  fill: currentColor; /* 图标颜色继承自父元素的文字颜色 */
}
</style>
